import { render } from "./rotate.vue?vue&type=template&id=fc0db7a2&scoped=true"
const script = {}

import "./rotate.vue?vue&type=style&index=0&id=fc0db7a2&scoped=true&lang=css"

import exportComponent from "E:\\Project\\New\\paypal-iframe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc0db7a2"]])

export default __exports__